import { EventListItemDto } from "../../autogen/bff-api";
import { EventStatusTag } from "../sourcing-events/EventStatusTag";

export const EventListItemStatusTag = ({
  event,
  size = "md",
}: {
  event: EventListItemDto;
  size?: "sm" | "md" | "lg";
}) =>
  event.publicStatus ? <EventStatusTag event={{ kind: "PUBLIC", status: event.publicStatus }} size={size} /> : null;
